export function custormAnchor(index) {
    console.log(index,'锚点滚动');
    //锚点滚动到固定位置
    let anchorElement = document.getElementById(index);
    if (anchorElement) {
        anchorElement.scrollIntoView();
    }
}